import type { ReactNode } from 'react'

import { cn } from '@/utils'

interface FactProps {
  label: string
  children: ReactNode
  className?: string
}

// One row of the account column: the fact's name on the left, quieter than the value it names.
export const Fact = ({ label, children, className }: FactProps) => (
  <>
    <dt className={cn('text-[11px] leading-5 text-ink-subtle', className)}>
      {label}
    </dt>
    <dd className={cn('flex min-w-0 text-[13px] leading-5', className)}>
      {children}
    </dd>
  </>
)
